/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../../showTost';
import emptyimg from "../../assets/Image/emptyOrder.png";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
export const ImgLoad = ({ url }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <img
      src={url}
      alt="Model"
      loading="lazy"
      onLoad={() => setImgLoaded(true)}
      onError={() => setImgLoaded(true)}
      className={`transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
    />
  )
}

const MyOrder = () => {

  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [currentOrder, setCurrentOrder] = useState([]);
  const [pastOrder, setPastOrder] = useState([]);
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [isCancelBox, setIsCancelBox] = useState("");
  const [selectReason, setSelectReason] = useState();
  const [otherReason, setOtherReason] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);

  const selectBtnRef = useRef(0);
  const Navigate = useNavigate();
  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);


  const Userid = secureLocalStorage.getItem("Userid");
  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  useEffect(() => {
    HandleFetchCurrentOrderData(1);
    axios.get(`${ApiBaseUrl}/customer/appint_cancel_list`)
      .then((res) => {
        // console.log("appint_cancel_list", res);
        setCancelReasonList(res.data.cancel_reason);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const HandleFetchCurrentOrderData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/medi_pending_order_list`, { uid: Userid, page })
        .then((res) => {
          // console.log("medi_pending_order_list", res.data);
          const { ResponseCode, running } = res.data;
          if (ResponseCode === 200) {
            if (running.length === 0 || totallength > running.length) NoMoreDataRef.current = false;
            if (page === 1) {
              setCurrentOrder(running);
              setTotalLength(running.length);
            } else {
              setCurrentOrder(prev => [...prev, ...running]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleFetchPastOrderData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/medi_complete_order_list`, { uid: Userid, page })
        .then((res) => {
          // console.log("medi_complete_order_list", res.data);
          const { ResponseCode, complete } = res.data;
          if (ResponseCode === 200) {
            if (complete.length === 0 || totallength > complete.length) NoMoreDataRef.current = false;
            if (page === 1) {
              setPastOrder(complete);
              setTotalLength(complete.length);
            } else {
              setPastOrder(prev => [...prev, ...complete]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage(prev => prev + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);

  useEffect(() => {

    if (page === 1 || !NoMoreDataRef.current) return;

    if (selectBtnRef.current === 0) {
      HandleFetchCurrentOrderData(page);
    } else {
      HandleFetchPastOrderData(page);
    }
  }, [page])

  const HandleGetInfo = (id, index) => {
    Navigate("/dashbord/order-details", { state: { id, index } });
  };

  const HandleCancelAppointment = () => {

    if (!selectReason) {
      showToast({ title: t("Select Cancel Reason"), id: "error" });
      return;
    }

    if (selectReason === 4 && !otherReason) {
      showToast({ title: t("Enter Other Reason"), id: "error" });
      return;
    }

    if (Userid) {

      const Data = {
        order_id: String(isCancelBox),
        cancel_id: selectReason,
        reason: otherReason ? otherReason : ""
      };

      axios.post(`${ApiBaseUrl}/customer/product_order_cancel`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            setIsCancelBox("");
            HandleFetchCurrentOrderData(page);
          }

        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleSelectBtn = (index) => {
    selectBtnRef.current = index;
    NoMoreDataRef.current = true;
    if (index === 0) {
      HandleFetchCurrentOrderData(1);
    } else {
      HandleFetchPastOrderData(1);
    }
  }

  return (
    <div>
      {loading
        ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
        : <div className="">
          <div className="flex justify-center mt-[25px]">
            <div className="bg-[#F6F7F8] Select-btn p-[5px] rounded-[50px] flex gap-[20px]">
              <button onClick={() => HandleSelectBtn(0)} className={`${selectBtnRef.current === 0 && "active"}`}>{t("Current Order")}</button>
              <button onClick={() => HandleSelectBtn(1)} className={`${selectBtnRef.current === 1 && "active"}`}>{t("Past Order")}</button>
            </div>
          </div>
          <div className="mybooking">
            {selectBtnRef.current === 0
              ? (currentOrder.length >= 1
                ? currentOrder.map((item, index) => {
                  return <div key={index} onClick={() => HandleGetInfo(item.id, 0)} className="card-box">
                    <ImgLoad url={ImgBaseUrl + item.image} />
                    <div className="p-[10px]">
                      <div className="flex items-center justify-between gap-[10px]">
                        <span className='text-gray-500 text-[14px] font-[500]'>{item.date}</span>
                        <p className='font-[500]'>Order Id : #{item.id}</p>
                      </div>
                      <div className="flex items-center justify-between gap-[10px]">
                        <h1 className='font-[500]'>{item.name}</h1>
                        <h1 className='font-[500]'>{currency}{item.tot_price}.00</h1>
                      </div>
                      <div className="flex items-center justify-between gap-[10px]">
                        <h1 className='font-[500]'>item : </h1>
                        <h1 className='font-[500]'>{item.tot_product}</h1>
                      </div>
                      <div className="flex items-center justify-between gap-[10px] mt-[10px]">
                        <button onClick={(e) => { e.stopPropagation(); setIsCancelBox(item.id) }} className='w-[100%] border-[1px] border-[red] text-[red] rounded-[50px] py-[5px] font-[500]'>{t("Cancel")}</button>
                        <button onClick={() => HandleGetInfo(item.id, 0)} className='w-[100%] border-[1px] border-[#0d4047] text-[#0d4047] rounded-[50px] py-[5px] font-[500]'>{t("Info")}</button>
                      </div>
                    </div>
                  </div>
                })
                : <div className='h-[400px] justify-center flex flex-col mx-auto items-center text-center'>
                  <img src={emptyimg} className='w-[200px]' alt="" />
                  <h1 className='font-[500] text-[18px]'>{t("No Order placed !!")}</h1>
                  <p className='text-gray-400'>{t("Currently You Don't Have Any Booking")}</p>
                </div>
              )
              : (pastOrder.length >= 1
                ? pastOrder.map((item, index) => {
                  return <div key={index} onClick={() => HandleGetInfo(item.id, 1)} className="card-box">
                    <div className="relative">
                      <ImgLoad url={ImgBaseUrl + item.image} />
                      <div className="absolute top-[10px] right-[15px]">
                        {item.status === "3"
                          ? <RiVerifiedBadgeFill className='text-green-400 text-[23px]' />
                          : <svg width="20" height="20" viewBox="0 0 24 24" fill="red" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 2H8C6.61347 2 5.33678 2.47031 4.32077 3.26011L9.75178 8.69112C10.3925 8.25495 11.1665 8 12 8C12.8335 8 13.6075 8.25495 14.2482 8.69112L19.6792 3.26011C18.6632 2.47031 17.3865 2 16 2ZM20.7399 4.32077L15.3089 9.75178C15.745 10.3925 16 11.1665 16 12C16 12.8335 15.745 13.6075 15.3089 14.2482L20.7399 19.6792C21.5297 18.6632 22 17.3865 22 16V8C22 6.61347 21.5297 5.33678 20.7399 4.32077ZM19.6792 20.7399L14.2482 15.3089C13.6075 15.745 12.8335 16 12 16C11.1665 16 10.3925 15.745 9.75178 15.3089L4.32077 20.7399C5.33678 21.5297 6.61347 22 8 22H16C17.3865 22 18.6632 21.5297 19.6792 20.7399ZM3.26011 19.6792L8.69112 14.2482C8.25495 13.6075 8 12.8335 8 12C8 11.1665 8.25495 10.3925 8.69112 9.75178L3.26011 4.32077C2.47031 5.33678 2 6.61347 2 8V16C2 17.3865 2.47031 18.6632 3.26011 19.6792Z" />
                          </svg>
                        }
                      </div>
                    </div>
                    <div className="p-[10px]">
                      <div className="flex items-center justify-between gap-[10px]">
                        <span className='text-gray-500 text-[14px] font-[500]'>{item.date}</span>
                        <p className='font-[500]'>Order Id : #{item.id}</p>
                      </div>
                      <div className="flex items-center justify-between gap-[10px]">
                        <h1 className='font-[500]'>{item.name}</h1>
                        <h1 className='font-[500]'>{currency}{item.tot_price}.00</h1>
                      </div>
                      <div className="flex items-center justify-between gap-[10px]">
                        <h1 className='font-[500]'>item : </h1>
                        <h1 className='font-[500]'>{item.tot_product}</h1>
                      </div>
                      <div className="flex items-center justify-between gap-[10px] mt-[10px]">
                        <button onClick={() => HandleGetInfo(item.id, 1)} className='w-[100%] border-[1px] border-[blue] text-[blue] rounded-[50px] py-[5px] font-[500]'>{t("Info")}</button>
                      </div>
                    </div>
                  </div>
                })
                : <div className='h-[400px] justify-center flex flex-col mx-auto items-center text-center'>
                  <img src={emptyimg} className='w-[200px]' alt="" />
                  <h1 className='font-[500] text-[18px]'>{t("No Order placed !!")}</h1>
                  <p className='text-gray-400'>{t("Currently You Don't Have Any Booking")}</p>
                </div>)}
          </div>
        </div>}

      {isCancelBox && <div onClick={() => setIsCancelBox("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
          <h1 className='font-bold text-center text-[18px]'>{t("Select Reason")}</h1>
          <p className='text-center text-[17px]'>{t("Please Select the Reason for Cancellation")} : </p>
          <div className="px-[10px]">
            {cancelReasonList.map((item, index) => {
              return <div onClick={() => setSelectReason(item.id)} key={index} className="py-[5px] cursor-pointer flex items-center">
                <div className="w-[30px] check-box">
                  <input id="radio1" className="peer hidden" type="radio" name="group1" />
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center ${selectReason === item.id ? "box-activeborder" : "box-border"}`}>
                    <span className={`w-[10px] h-[10px] rounded-full duration-[0.3s] ${selectReason === item.id && "box-activebg"}`}></span>
                  </div>
                </div>
                <h1>{item.title}</h1>
              </div>
            })}
            {selectReason === 4 && <input type="text" onChange={(e) => setOtherReason(e.target.value)} className='border-[1px] focus-within:outline-[#0d4047] border-[#8080803b] w-[100%] py-[8px] px-[10px] rounded-[10px]' placeholder='Enter reason' />}
          </div>
          <div className="flex items-center gap-[20px] mt-[10px]">
            <button onClick={() => setIsCancelBox("")} className='w-[100%] bg-red-400 hover:bg-red-500 py-[6px] font-[500] text-white rounded-[50px]'>{t("Cancel")}</button>
            <button onClick={HandleCancelAppointment} className='w-[100%] bg-[#000000c2] hover:bg-black py-[6px] font-[500] text-white rounded-[50px]'>{t("Confirm")}</button>
          </div>
        </div>
      </div>}

    </div>
  )
}

export default MyOrder
/* jshint ignore:end */